// extracted by mini-css-extract-plugin
module.exports = {"root":"EventWrapper_root__18Fh3","noInteraction":"EventWrapper_noInteraction__arjmi"};